import type { Entity } from "types";
import { fetchApi } from "infrastructure/api";
import { HttpVerb } from "consts/api";
import { ApiRoutes } from "consts/enpoints/api";
import type {
    HighRiskMerchant,
    OnboardingRequestParams,
    WithUser
} from "features/ecommerce/types";

export const getOnboardingsHighRiskBusinessInformationSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsHighRiskBusinessInformationSteps(userId));

export const putOnboardingsHighRiskBusinessInformationSteps = (body: OnboardingRequestParams & Partial<HighRiskMerchant.OnboardingBusinessInformation>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsHighRiskBusinessInformationSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsHighRiskDirectorsAndShareholdersSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsHighRiskDirectorsAndShareholdersSteps(userId));

export const putOnboardingsHighRiskDirectorsAndShareholdersSteps = (body: OnboardingRequestParams & Partial<HighRiskMerchant.OnboardingDirectorsAndShareholders>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsHighRiskDirectorsAndShareholdersSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsHighRiskFinancialInformationSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsHighRiskFinancialInformationSteps(userId));

export const putOnboardingsHighRiskFinancialInformationSteps = (body: OnboardingRequestParams & Partial<HighRiskMerchant.OnboardingFinancialInformation>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsHighRiskFinancialInformationSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsHighRiskComplianceSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsHighRiskComplianceSteps(userId));

export const putOnboardingsHighRiskComplianceSteps = (body: OnboardingRequestParams & Partial<HighRiskMerchant.OnboardingRiskAndCompliance>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsHighRiskComplianceSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsHighRiskMarketingAndSupportSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsHighRiskMarketingWebsiteAndSupportSteps(userId));

export const putOnboardingsHighRiskMarketingAndSupportSteps = (body: OnboardingRequestParams & Partial<HighRiskMerchant.OnboardingMarketingWebsiteAndSupport>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsHighRiskMarketingWebsiteAndSupportSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsHighRiskUploadDocumentsSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsHighRiskUploadDocumentsSteps(userId));

export const putOnboardingsHighRiskUploadDocumentsSteps = (body: OnboardingRequestParams & Partial<HighRiskMerchant.OnboardingUploadDocuments>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsHighRiskUploadDocumentsSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const deleteOnboardingsHighRiskShareholderIdentities = ({ userId, pki }: WithUser & Entity) =>
    fetchApi(ApiRoutes.DeleteOnboardingsHighRiskShareholderIdentities(userId, pki), {
        method: HttpVerb.Delete
    });
